import {useContext} from "react";

const withContext = (WrappedComponent, Context) => {
    return function ContextWrapper(props) {
        const contextValue = useContext(Context);
        return <WrappedComponent {...props} {...contextValue} />;
    };
};

export default withContext;